export default "__VITE_PUBLIC_ASSET__e423e657__"